module.exports = __webpack_public_path__ + "static/media/img-5.33cf6a2a.jpg";